export const corporate_name = 'IRE Yogyakarta'